import backend from './backend'

export default {
    getAccount(){
        return backend.get('/stripe/account')
    },
    createAccount(){
        return backend.post('/stripe/account')
    },
    linkAccount(accountId){
        return backend.post(`/stripe/link/${accountId}`)
    }
}
